import Offcanvas from "react-bootstrap/Offcanvas";
import "bootstrap/dist/css/bootstrap.min.css";
import styles from "../../screens/InternalTracker/InternalTracker.module.css";
import { Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";

function SelectedcandidateViewDrawer({
  handleClose,
  show,
  selectedCandidate,
  handleOnSendJob,
}) {
  const requirementLoading = useSelector(
    (state) => state.postrequirement.status
  );
  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      placement="bottom"
      scroll={false}
      backdrop={false}
      style={{
        border: "none",
        // marginTop: "74px",
        width: "100%",
        height: "10%",
        padding: "0 0 0 10px",
        boxShadow: "-4px 0 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Offcanvas.Body style={{ padding: "0", marginTop: "20px" }}>
        <Box
          className={styles.internal_update_btns}
          sx={{ padding: "2px 20px !important", margin: "0 !important" }}
        >
          <Box sx={{ position: "relative", left: "250px" }}>
            <span>
              <Typography>
                You have selected {selectedCandidate?.length} candidates for
                this job
              </Typography>
              <Typography>
                <b>2 Credit will deduct after successfully delivered </b>
              </Typography>
            </span>
          </Box>
          <Box>
            <button
              style={
                selectedCandidate?.length === 0
                  ? {
                      backgroundColor: "#3856a6",
                      padding: "7.5px 15px",
                      cursor: "not-allowed",
                    }
                  : { backgroundColor: "#3856a6", padding: "7.5px 15px" }
              }
              onClick={handleOnSendJob}
              disabled={selectedCandidate?.length === 0}
            >
              {requirementLoading === "loading" ? "Loading" : "Send Now"}
            </button>
          </Box>
        </Box>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default SelectedcandidateViewDrawer;
